'use client';

import { c as _c } from "react/compiler-runtime";
import { AnimatePresence, type Transition, type Variants, motion } from 'motion/react';
import React, { type ReactNode } from 'react';
import { Modal } from '~/components/primitives';
import { cx } from 'class-variance-authority';
const SlideUp: React.FC<{
  children: ReactNode | ReactNode[];
  className?: string;
  open: boolean;
  onClose: () => void;
}> = props => {
  const $ = _c(13);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      closed: {
        y: "100%"
      },
      open: {
        y: "0%"
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const VARIANTS = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      duration: 0.3,
      ease: "easeInOut"
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const TRANSITION = t1;
  let t2;
  if ($[2] !== props) {
    t2 = props.open && <Modal.Background className="left-0 z-10" onClick={() => props.onClose()} />;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <AnimatePresence>{t2}</AnimatePresence>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props) {
    t4 = props.open && <motion.aside variants={VARIANTS} initial="closed" exit="closed" animate="open" transition={TRANSITION} className={cx("fixed right-0 bottom-0 left-0 z-20 overflow-hidden rounded-t-4xl border border-blue-100 bg-white shadow-lg shadow-black/30", props.className)}><Modal.CloseButton onClick={() => props.onClose()} className="top-5! right-5" />{props.children}</motion.aside>;
    $[6] = props;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <AnimatePresence>{t4}</AnimatePresence>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <>{t3}{t5}</>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
export default SlideUp;